'use client';
import Image from 'next/image';
import { CSSProperties } from 'styled-components';
import { useRouter } from 'next/navigation';

import { LinkViewModel } from '@api/index';

import {
  Description,
  HeroCampaignBannerContainer,
  ImageWrapper,
  InfoHeader,
  MainHeader,
  SecondHeader,
  TextContainer,
  FadeOutLayout,
  LinkDescWrapper,
  CampaignDetailsButton,
  CampaignDetailsButtonText,
} from './HeroCampaignBannerStyles';

interface StylesProps {
  descFontSize?: number;
  mainTextFontSize?: number;
  secondTextBottomMargin?: number;
  descTextBottomMargin?: number;
  linTextSize?: number;
  fadeOutLayoutStyle?: CSSProperties;
  linkDescWrapperStyle?: CSSProperties;
  descriptionStyle?: CSSProperties;
  linkWrapperStyle?: CSSProperties;
  textContainerStyles?: CSSProperties;
}

export interface ILandingHeroCampaignBannerProps {
  id?: string;
  imgSrc?: string;
  mainText: string;
  secondText: string;
  description: string;
  link: string;
  linkName?: string;
  alt?: string;
  styles: StylesProps;
}
interface HeroCampaignBannerProps {
  listing?: boolean;
  images?: string;
  data: ILandingHeroCampaignBannerProps;
  pageName?: string;
  showButton?: boolean;
  ctaText?: LinkViewModel[];
}
const HeroCampaignBannerNonListing = ({
  data: {
    alt,
    description,
    imgSrc,
    link,
    mainText,
    secondText,

    styles: {
      descTextBottomMargin = 38,
      descFontSize = 18,
      secondTextBottomMargin = 20,
      mainTextFontSize = 36,
      fadeOutLayoutStyle = {},
      linkDescWrapperStyle = {},
      textContainerStyles = {},
      descriptionStyle = {},
    } = {},
  },
  showButton,
  ctaText,
}: HeroCampaignBannerProps) => {
  const router = useRouter();

  return (
    <HeroCampaignBannerContainer>
      {imgSrc ? <FadeOutLayout style={fadeOutLayoutStyle} /> : null}
      <ImageWrapper noBg={imgSrc === undefined}>
        <>
          {imgSrc ? (
            <Image
              src={imgSrc}
              fill
              style={{ objectFit: 'cover' }}
              alt={alt || 'setur'}
            />
          ) : null}
        </>

        <TextContainer style={textContainerStyles} noBg={imgSrc === undefined}>
          <InfoHeader>
            <MainHeader fontSize={mainTextFontSize}>{mainText}</MainHeader>
            <SecondHeader
              fontSize={mainTextFontSize}
              bottomMargin={secondTextBottomMargin}
            >
              {secondText}
            </SecondHeader>
          </InfoHeader>

          <LinkDescWrapper
            noBg={imgSrc === undefined}
            style={linkDescWrapperStyle}
          >
            <Description
              fontsize={descFontSize || 14}
              bottomMargin={descTextBottomMargin}
              noBg={imgSrc === undefined}
              style={descriptionStyle}
            >
              {description}
            </Description>
            {ctaText?.[0]?.name ? (
              <>
                {showButton && (
                  <div>
                    <CampaignDetailsButton
                      onClick={() => {
                        router.push(link);
                      }}
                    >
                      <CampaignDetailsButtonText>
                        {ctaText?.[0]?.name}
                      </CampaignDetailsButtonText>
                    </CampaignDetailsButton>
                  </div>
                )}
              </>
            ) : null}
          </LinkDescWrapper>
        </TextContainer>
      </ImageWrapper>
    </HeroCampaignBannerContainer>
  );
};

export default HeroCampaignBannerNonListing;
